var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-insta {\r\n        stroke-width: 4.27px;\r\n      }\r\n\r\n      .cls-insta, .cls-insta2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-insta2 {\r\n        stroke-width: 5.69px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    className: "cls-insta2",
    x: 5.16,
    y: 5.16,
    width: 100.23,
    height: 100.23,
    rx: 16.17,
    ry: 16.17
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    className: "cls-insta",
    cx: 55.27,
    cy: 55.27,
    r: 27.49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    className: "cls-insta",
    cx: 85.99,
    cy: 24.56,
    r: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    className: "cls-insta",
    d: "M66.5,39.47c-8.67-6.26-20.76-4.31-27.02,4.36-4.89,6.77-4.89,15.9,0,22.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    className: "cls-insta",
    d: "M44.05,71.07c8.67,6.26,20.76,4.31,27.02-4.36,4.89-6.77,4.89-15.9,0-22.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramTop);
export default __webpack_public_path__ + "static/media/instagram-top.4c0179abfabe49b22444b2aadd9f84a8.svg";
export { ForwardRef as ReactComponent };